import { render } from "./LogoWTextSvg2.vue?vue&type=template&id=77077536"
import script from "./LogoWTextSvg2.vue?vue&type=script&lang=js"
export * from "./LogoWTextSvg2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__